export default __webpack_public_path__ + "static/media/logo_ensembl.0c4bddf7.svg";